export default __webpack_public_path__ + "static/media/arm-head-new-crop.50238db6.jpg";